<template>
  <div>
    <delivery-search
      :is-delivery-estimate="true"
      :visible-stores-limit="visibleStoresLimit"
      @set-total-stores="setTotalStores"
    />

    <div class="mb-2 text-center">
      <p-button
        type="info"
        round
        @click="goNextStep"
      >
        Go to Next
      </p-button>

      <p-button
        v-if="isLoadMoreBtnVisible"
        class="ml-2"
        type="purple"
        round
        @click="loadMoreRestaurants"
      >
        Load More Options
      </p-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useGourmet } from '@/use/gourmet';
import { ref, computed, onMounted } from 'vue';

import DeliverySearch from '../DeliverySearch.vue';

const visibleOffset = 6;
const emit = defineEmits(['goto-next-step']);

const totalStoresCount = ref(0);
const visibleStoresLimit = ref(6);

const isLoadMoreBtnVisible = computed(() => totalStoresCount.value > visibleStoresLimit.value);
const { setSavedCart } = useGourmet();

const setTotalStores = (count: number) => {
  totalStoresCount.value = count;
};

const goNextStep = () => {
  emit('goto-next-step');
};

const loadMoreRestaurants = () => {
  visibleStoresLimit.value += visibleOffset;
};

onMounted(() => {
  setSavedCart(null);
});
</script>
